import React from 'react';
import CallToActionWidget from 'applications/static-pages/cta-widget';

const ViewDependentsCTA = () => {
  return (
    <div>
      <CallToActionWidget appId="view-dependents" />
    </div>
  );
};

export default ViewDependentsCTA;
